//import { DOMAIN_TITLE, WWW_IMAGE_PATH } from '@/config/env';

export function debounce (fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
              fn.apply(that, args);
        }, delay);
    }
}

export default {
    methods: {
        $updatePageTitle(to, from) {
            let pageTitle = to.matched.find(item => item.meta.title);
            (pageTitle)
                ? window.document.title = pageTitle.meta.title
                : window.document.title = DOMAIN_TITLE;
            //next();
        },
        
        $scrollToTop(){
            window.scrollTo(0,0);
        },
        $scrollTo(id) {
            var element = document.getElementById(id);
            //console.log(element.offsetTop);
            element.scrollIntoView();
            //var top = element.offsetTop;
      },
        $tomorrowDate() {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate()+1); 
            return tomorrow;
        },
        $getNavItem(value){
            return this.$getItemFromContents("navigation", value).text;            
        },
        $getContent(page, value){
          return this.$getItemFromContents(page, value).text;             
       },
        $getItemFromContents(contentId, itemName , customLng) {
            var contents = this.$store.state.contents[contentId];
            var lng =(!customLng) ? this.$getLng() : customLng;
            //console.log("getItemFromContents =>" + contentId + " -> " + itemName + " " + contents.length + ' => ' + lng);
            
            if (this.$checkNull(contents))
            {
                var res = contents.find(item => item.label == itemName );
                if (this.$checkNull(res))
                {
                    res[lng]['images'] = res.images;
                    return res[lng];
                }
                console.log(itemName + " doesn't exist");
                return false;

            }
            else
            {
                console.log("contents empty for " + contentId  + " => " + itemName);
                return false;
            }
        },
        $getItemFromConfig(value, configName, configLabel){
            var configs = this.$store.state.contents[configName];
            
            if (this.$checkNull(configs))
            {
                var res = configs.find(item => item[configLabel] == value );
                if (this.$checkNull(res))
                {
                    return res;
                }
                console.log(value + "," + configName +"," + configLabel + " doesn't exist");
                return false;

            }
            else
            {
                console.log("configs empty for " + value + "," + configName +"," + configLabel );
                return false;
            }
        },
        
        $getMetaTag(page){
            //console.log("metaTag for: " + page);
            return {
                title: this.$getItemFromContents(page, "meta_titre").text,
                    //titleTemplate: '%s - Yay!',
                htmlAttrs: {
                    lang: this.$getLng(),
                    amp: false
                },
                meta: [
                    { name: 'description', content: this.$getItemFromContents(page, "meta_description").text, },
                ],      
            };
        
        },
        /*
        $validityCheck(context) {
            setInterval(() => {
                if (context.formstate.$invalid) {
                    context.requiredMsg = 'Remplissez les champs requis SVP';
                    context.disabled = true;
                } else {
                    context.requiredMsg = '';
                    context.disabled = false;
                }
            }, 1000)
        },*/
        $checkNull(value) {
            if (value === '' || value === false || value === null  || value === 'undefined' || value === undefined) {
                return false;
            }
            return true;
        },
        
        $checkMobileFormat(){
            if (this.$store.getters.getWindowSize.width < 968) 
                return true;
            return false;
        },
        $closeDetailBox(){
            this.showDetail = false;
        },
        $toggleCurrentLanguage(){
            this.$store.state.lngFront = (this.$store.state.lngFront == 'fr') ? this.$store.state.lngFront = 'en' : this.$store.state.lngFront = 'fr';
            this.$changeLngUrl();
            //this.$route.params.extLng = this.$store.state.lngFront;
        }, 
        $getLng(){
            return this.$store.getters.currentLng;
        },
        $checkSearchString(searchValue){
            //-- replace invalid chars
           searchValue = searchValue.replace(/[^a-zA-Z0-9éàèê]/g, '');
           if (!this.$checkNull(searchValue) ||searchValue.length < 3) 
               return false;
           else
               return searchValue;
        },
        
        $formatDateUs(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getFullYear() + "-" + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
        },
        $formatDateNews(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return ( startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + startingDate.getFullYear();
        },        
        $formatDateTimeFr(date) {
            //-- date must be US YYYY/MM/DD HH:MM
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString('fr-fr', { month: 'short' });
            var day = startingDate.toLocaleString('fr-fr', { weekday: 'short' });
            var dayInt = startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var hours = startingDate.getHours().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var minutes = startingDate.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 });

            return day + ' ' + dayInt + ' ' + month + ' ' + startingDate.getFullYear() + ' ' + hours + ':' + minutes;
        },

        $formatDateFr(date, noWeekDay = false) {
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "long" });
            var day = (noWeekDay) ? startingDate.toLocaleString("fr-fr", { weekday: "long" }) : '';
            return day + " " + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + " " + month + " " + startingDate.getFullYear();
        },
        $formatDateFr2(date, noWeekDay = false) {
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "long" });
            return month + " " + startingDate.getFullYear();
        },        
        $processExecMsg(data) {
            if (!this.$checkNull(data))
                this.$Notification.error(data.replace(/<[^>]+>/g, ''));
            else
                if (this.$checkNull(data.result)) {
                    const code = data.result.code;
                    const msg = data.result.msg;

                    if (code == '100')
                    {
                        this.$Notification.success(`${msg}`);
                        return true;
                    }
                    else
                        this.$Notification.warn(`${msg}`);
                } else {
                    //-- No return formated, displaying raw result | removing html
                    this.$Notification.error(data.replace(/<[^>]+>/g, ''));
                }
            
            return false;
        },

        $processDataMsg(data) {
            if (this.$checkNull(data.code)) {
                //this.$Notification.warn(`Code: ${data.code} || Msg: ${data.msg}`)
                this.$Notification.warn(`${data.msg}`)
                return false;
            }
            else
                return true;
        },
        $formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        $preloadImages(urls, allImagesLoadedCallback){
            var loadedCounter = 0;
            var toBeLoadedNumber = urls.length;
            urls.forEach((url) => {
                this.$preloadImage(url, function(){
                    loadedCounter++;
                    //console.log('Number of loaded images: ' + loadedCounter);
                    if(loadedCounter == toBeLoadedNumber){
                        allImagesLoadedCallback();
                    }
                });
            });
        },        
         $preloadImage(url, anImageLoadedCallback){
             var img = new Image();
             img.onload = anImageLoadedCallback;
             img.src = url;
         },
        $hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        $existValueArrays(tab1, tab2) {
            if (!Array.isArray(tab1)) return false;
            if (!Array.isArray(tab2)) tab2 = [tab2];
            var rs = false;
            if (this.$checkNull(tab1)) {
                for (var i = 0; i < tab1.length; i++) {
                    if (this.$checkNull(tab2))
                        tab2.forEach((item) => {
                            if (tab1[i] == item)
                                rs = true;
                        });
                    if (rs) return true;
                }
            }
        },
        $getSelectData(value){
           return this.$store.state.contents[value]; 
        },

    }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js